import styled from "styled-components";

export default c => styled(c)`
  .filter-title {
    padding-bottom: 4px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/management/multilocality-sales-report/filter/style.js